import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { TrackedObject } from 'tracked-built-ins';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  'label': validator('presence', {
    presence: true,
    disabled: readOnly('model.isDisplayOnly'),
  }),
  'settings.maxLength': validator('number', {
    allowBlank: true,
    allowString: true,
    integer: true,
    disabled: readOnly('model.isNotTextOrTextareaType'),
  }),
});

export default class ContestFormFieldModel extends Model.extend(Validations) {
  @attr('string') label;
  @attr('string') type;
  @attr('boolean', { defaultValue: false }) required;
  @attr('number', { defaultValue: 0 }) position;
  @attr('json', {
    defaultValue() {
      return new TrackedObject({});
    },
  })
  settings;

  @belongsTo('contest', { async: true, inverse: 'formFields' }) contest;

  // Getter and setter
  get displayHeadline() {
    return this.label;
  }

  get displayLabel() {
    return this.label;
  }

  @computed('type')
  get isDivider() {
    return this.type === 'divider';
  }

  @computed('type')
  get isDisplayOnly() {
    return ['divider', 'infotext'].includes(this.type);
  }

  get isNotTextOrTextareaType() {
    return !['text', 'textarea'].includes(this.type);
  }
}
